import { render, staticRenderFns } from "./LicenseFieldsSelect.vue?vue&type=template&id=4115e157&scoped=true"
import script from "./LicenseFieldsSelect.vue?vue&type=script&lang=js"
export * from "./LicenseFieldsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115e157",
  null
  
)

export default component.exports